export const SIDES = [
  'Blettes persillées, frites, haricots verts, pomme de terre thym, cardons et leur sauce béchamel',
  'Carottes herbes provencales, frites, cardons',
  "Les accompagnements, une liste d'éléments séparés généralement par des virgules",
];
